import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="105"
    height="104"
    viewBox="0 0 105 104"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M52.5 0C42.2154 0 32.1617 3.04975 23.6104 8.76358C15.059 14.4774 8.39404 22.5987 4.45829 32.1005C0.522531 41.6022 -0.507243 52.0577 1.49919 62.1447C3.50562 72.2317 8.45814 81.4972 15.7305 88.7696C23.0028 96.0419 32.2683 100.994 42.3553 103.001C52.4423 105.007 62.8978 103.977 72.3996 100.042C81.9013 96.106 90.0226 89.441 95.7364 80.8896C101.45 72.3383 104.5 62.2846 104.5 52C104.484 38.2136 99.0004 24.9965 89.252 15.248C79.5035 5.49961 66.2864 0.015934 52.5 0ZM77.2656 42.8945L47.9297 70.8945C47.1838 71.6042 46.1937 72 45.1641 72C44.1345 72 43.1444 71.6042 42.3985 70.8945L27.7344 56.8945C26.9683 56.1607 26.5248 55.1527 26.5013 54.0921C26.4778 53.0315 26.8763 52.0049 27.6092 51.2379C28.342 50.4708 29.3494 50.0261 30.41 50.0012C31.4706 49.9764 32.4977 50.3736 33.2656 51.1055L45.1641 62.4688L71.7344 37.1055C72.5024 36.3736 73.5294 35.9764 74.59 36.0012C75.6506 36.0261 76.658 36.4708 77.3909 37.2379C78.1238 38.0049 78.5222 39.0315 78.4987 40.0921C78.4753 41.1527 78.0318 42.1607 77.2656 42.8945Z"
      fill="currentColor"
    />
  </svg>
}

export default SvgComponent;
